module.exports = __webpack_public_path__ + "img/registration_blaupause.7004a2c6.gif";